module.exports = __webpack_public_path__ + "static/media/Monde_Cocktail2_bar.09a795e7.png";